var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCandle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75h-7zM2 18.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75H2zM19 7.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3zM2 7.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21.25c-1.72 0-2.75-1.03-2.75-2.75v-2c0-1.72 1.03-2.75 2.75-2.75h6c1.72 0 2.75 1.03 2.75 2.75v2c0 1.72-1.03 2.75-2.75 2.75H7zM5.75 16.5v2c0 .89.36 1.25 1.25 1.25h6c.89 0 1.25-.36 1.25-1.25v-2c0-.89-.36-1.25-1.25-1.25H7c-.89 0-1.25.36-1.25 1.25zM11 10.25c-1.72 0-2.75-1.03-2.75-2.75v-2c0-1.72 1.03-2.75 2.75-2.75h6c1.72 0 2.75 1.03 2.75 2.75v2c0 1.72-1.03 2.75-2.75 2.75h-6zM9.75 5.5v2c0 .89.36 1.25 1.25 1.25h6c.89 0 1.25-.36 1.25-1.25v-2c0-.89-.36-1.25-1.25-1.25h-6c-.89 0-1.25.36-1.25 1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCandle2);
export default __webpack_public_path__ + "static/media/vuesax-outline-candle-2.db1a9d05a1bce8be0455d2059b88ef61.svg";
export { ForwardRef as ReactComponent };